export function anchors() {
    const body = $("body");
    const $menu = $(".header")

    body.on('click', ".has-anchor", function (e) {
        e.preventDefault();

        const target = $(this).attr("href");

        const anchoredBlock = $(target);
        const headerHeight = $menu.length ? $menu.innerHeight() : 0;
        if (anchoredBlock.length) {
            $("html, body").animate({scrollTop: anchoredBlock.offset().top - headerHeight - 25}, 500);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchors.js